import type { Ride } from '../../domain/ride';
import { calculateRideMetrics } from '../../domain/ride';
import { studioDraftSchema, studioVideoRequest, type StudioDraft } from '../studio-draft';
import { resolveExportTiming } from '../../../../renderer/src/export-range';

export function readCompositionFile(value: unknown): { ride: Ride; draft: StudioDraft } {
  if (!value || typeof value !== 'object') throw new Error('Choose a saved Studio composition.');
  const candidate = value as { version?: number; ride?: Ride; draft?: unknown };
  if (candidate.version !== 1 || !candidate.ride || !['fit', 'gpx', 'tcx'].includes(candidate.ride.source))
    throw new Error('This file has no supported recorded trace.');
  calculateRideMetrics(candidate.ride.sourcePoints ?? candidate.ride.points);
  return { ride: candidate.ride, draft: studioDraftSchema.parse(candidate.draft) };
}
export function downloadComposition(ride: Ride, draft: StudioDraft, social: boolean) {
  const metrics = ride.metrics ?? calculateRideMetrics(ride.sourcePoints ?? ride.points);
  const request = studioVideoRequest(ride, draft, social, metrics.distanceKilometers);
  const timing = resolveExportTiming(request);
  const value = { version: 1, ride, draft, format: draft.preset, request,
    source: { fileName: ride.sourceFileName, sha256: ride.sourceFingerprint,
      selection: draft.exportRange ?? { inFrame: 0, outFrame: timing.filmFrames - 1 }, framesPerSecond: 30 } };
  const url = URL.createObjectURL(new Blob([JSON.stringify(value, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a'); link.href = url;
  link.download = `${draft.title.replace(/[^a-zA-Z0-9 -]/g, '').trim() || 'Trace'}-composition.json`;
  link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
